import React from "react";

const Entrada2 = () => {
  // Sample news data for the sidebar
  const latestNews = [
    {
      id: 1,
      title: "Espacios de trabajo para todos: cómo la accesibilidad impulsa productividad, inclusión y bienestar",
      excerpt: "Quería comenzar este artículo con datos técnicos y aclaraciones normativas, pero luego pensé: a veces es más efectivo transmitir una idea a través de una experiencia real....",
      link: "/espacio-de-trabajo-para-todos",
    },
    {
      id: 2,
      title: "Hogar accesible, vida autónoma: la clave de viviendas inclusivas para personas mayores y con discapacidad",
      excerpt: "Diseñar viviendas accesibles no solo mejora la autonomía y calidad de vida de personas con discapacidad o adultos mayores, sino que también previene accidentes y permite que sus habitantes permanezcan en el hogar por más tiempo...",
      link: "/hogar-accesible-vida-autonoma",
    },
   
  ];

  return (
    <>
      <div className="container">
        <div className="row row-jm">
          {/* Main Content Column (8 units on medium screens) */}
          <div className="col-md-8 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">
            Hogar accesible, vida autónoma: la clave de viviendas inclusivas para personas mayores y con discapacidad
            </h2>

            <img
              src={require("../assets/home/ava.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "100%",
              }}
            />
            <p>Fecha: 25/05/2025</p>
            <div className="article-content">
              <p className="text-justify">
              Diseñar viviendas accesibles no solo mejora la autonomía y calidad 
              de vida de personas con discapacidad o adultos mayores, sino que
              también previene accidentes y permite que sus habitantes permanezcan 
              en el hogar por más tiempo. Diseñar nuestras viviendas desde un concepto
               basado en la accesiblidad, es vital para que estas sean funcionales 
               y de calidad. 
              </p>

              <p className="text-justify">
              Cuando pensamos en habitar un espacio, lo primero que viene a nuestra mente 
              es nuestro hogar: el lugar donde realizamos nuestras actividades cotidianas 
              y compartimos con nuestros seres queridos. La forma en que percibimos ese
               espacio cambia según la etapa de vida en la que nos encontremos: no es
                igual ser niño, adulto o adulto mayor. En el caso de las personas
                 con discapacidad, especialmente quienes nacen con ella, las necesidades son diversas y rara vez se ven reflejadas en la oferta de viviendas que existe actualmente.
              </p>

              <p className="text-justify">
              Según la Primera Encuesta Nacional Especializada sobre Discapacidad (ENEDIS, 2012), el 22,8 % de las personas con discapacidad afirma tener dificultades para movilizarse dentro de su propia vivienda. A esto se suma que el 77,7 % vive en viviendas propias. Sin embargo, la oferta de viviendas accesibles sigue siendo muy limitada, y las normativas vigentes no exigen de forma contundente la implementación de medidas de accesibilidad en espacios habitacionales.
              </p>

              <p className="text-justify">
              Es cierto que la vivienda es un espacio privado y cada propietario puede adaptarla según sus necesidades. Pero, si lo pensamos bien, ¿quién no desearía vivir en un espacio cómodo, seguro, flexible, bien iluminado, ventilado y fácil de usar, tenga o no una discapacidad?
              </p>

              <p className="text-justify">
              Todos, en algún momento, hemos tenido que remodelar nuestro hogar para ajustarlo a nuevas necesidades. ¿Qué pasaría si las viviendas ya incluyeran ciertas características que facilitaran estas adaptaciones futuras? ¿Y si existiera una oferta de viviendas pensadas para distintos grupos con requerimientos específicos?
              </p>

              <p className="text-justify">
              Aunque en muchos países —y también en el nuestro— se han hecho esfuerzos por promover viviendas más accesibles, aún queda mucho por hacer. Una vivienda accesible no solo mejora la calidad de vida de quienes la habitan, también representa una inversión. Aporta seguridad, independencia, y evita gastos elevados en remodelaciones futuras. Además, incrementa el valor de la propiedad en el mercado.
              </p>

              <p className="text-justify">
              No se trata de estandarizar hogares ni imponer un único modelo de vivienda. Se trata de comenzar por lo básico: mejorar dimensiones, asegurar pasillos amplios, puertas accesibles, instalar manijas adecuadas, incorporar rampas, ascensores, barandas y una mejor orientación en edificios multifamiliares.
              </p>

              <p className="text-justify">
              La accesibilidad en el hogar es el inicio de la cadena de accesiblidad en la ciudad. Y todo comienza, literalmente, en casa.
              </p>

              
            </div>
          </div>

          {/* Sidebar Column (4 units on medium screens) */}
          <div className="col-md-4 col-sm-12 mt-5">
            <div className="sidebar-card">
              <h3 className="sidebar-title">Últimas Noticias</h3>
              <div className="news-list">
                {latestNews.map((news) => (
                  <div key={news.id} className="news-item">
                    <a href={news.link} className="news-link">
                      <h4 className="news-title">{news.title}</h4>
                      <p className="news-excerpt">{news.excerpt}</p>
                    </a>
                  </div>
                ))}
              </div>

              <div className="more-news-link">
                <a href="/noticias">
                <button className="contact-button">Ver mas noticias</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Entrada2;
